<template lang="html">
  <v-page :profile="profile">

      <v-topbar :profile="profile"/>
      <v-breadcrumb :steps="[
        {label:'Perfil'}
      ]"/>

    <v-container>
      <v-card>
        <v-row class="size-0">
          <v-col :xs="12" :lg="4" class="border-right">
            <div class="p-3">
              <v-avatar
                :name="clientProfile.name + ' ' + clientProfile.lastname"
                :about="clientProfile.city + ' ' + clientProfile.state"
                :image="clientProfile.avatar"
              ></v-avatar>

            <v-list class="user-profile mt-4">
              <v-text tag='div'>Celular: <span>{{ clientProfile.cel_phone}}</span></v-text>
              <v-text tag='div'>Email: <span>{{ clientProfile.email }}</span></v-text>
              <v-text tag='div'>Skype: <span>{{ clientProfile.skype}}</span></v-text>
              <v-text tag='div'>Hangout: <span>{{ clientProfile.hangout}}</span></v-text>
              <v-text tag='div'>LinkedIn: <v-link :href="clientProfile.linkedin" :title="clientProfile.linkedin" target="_blank">Acessar</v-link></v-text>
            </v-list>
            <v-divider line/>
            <div class="text-right">
              <small><v-link @click="showProfileModal()">Editar</v-link></small>
            </div>

          </div>
          </v-col>
          <v-col :xs="12" :lg="8">

            <div class="p-3">
              <v-text tag="h5">Empresa para contratos</v-text>
              <p>
                Informe os dados da sua empresa para serem aplicados nos contratos de profissionais.<br>
              </p>
              <v-list class="list-block">
                <v-item tag="li" v-for="company in clientProfile.client_companies" class="px-0 d-flex justify-content-between align-items-center">
                  <span>
                    <div>
                      {{company.fantasy_name}}
                    </div>
                  </span>
                  <span class="text-right">
                    <!-- <div>
                    Gerente comercial
                    </div> -->
                    <small><v-link @click="showCompanyModal(company)">Editar</v-link></small>
                  </span>
                </v-item>
              </v-list>
              <br>
              <v-alert>
                Se quiser assinar contratos como pessoa física, informe os dados necessários editando o seu perfil ao lado.
              </v-alert>
              <!--div class="text-right mt-3">
                <v-link @click="edit_company_modal_show = true">Adicionar outra</v-link>
              </div-->
            </v-inner>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <!-- MODALS -->
    <v-vibbrant-profile-modal
      name="edit-profile-client"
      :show="edit_profile_modal_show"
      :data="{client: clientProfile}"
      @onHide="edit_profile_modal_show = false"
    />
    <v-modals
      title="Editar empresa"
      name="form-company"
      :show="edit_company_modal_show"
      :data="{client_company: selectedCompany, client: clientProfile}"
      @onHide="edit_company_modal_show = false"
    />
  </v-page>
</template>

<script>
import clientApi from '@/api/client'
import ClientProfileModal from '@/parts/modals/client-profile-edit'

export default {
  props: {
    profile: String
  },
  components: {
    'v-vibbrant-profile-modal': ClientProfileModal
  },
  data() {
    return {
      name: this.$store.state.auth.user.name,
      local: this.$store.state.auth.user.local,
      edit_profile_modal_show: false,
      edit_company_modal_show: false,
      selectedCompany: {}
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    showProfileModal() {
      this.edit_profile_modal_show = true
    },
    showCompanyModal(company) {
      this.selectedCompany = company
      this.edit_company_modal_show = true
    },
    fetchData() {
      clientApi.getClientData().then((response) => {
        if (response.status === 200) {
          this.$store.dispatch('loadClientProfileData', response.data)
        }
      }).catch((e) => {
        this.$notify(e, 'error')
      })
    }
  },
  computed: {
    clientProfile() {
      return this.$store.getters.clientProfile
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/parts/pages/client/profile.vue